import { SEEDED_VERSION_TITLE_PLACEHOLDER } from "@cabal/shared/domain/session/version/predicates.js";
import { UNTITLED_VERSION_LABEL } from "./versionPresentationLabels";

const EMPTY_TITLE_MARKER_PATTERN = /^\(\s*empty\s*\)$/i;

export function hasEmptyContentTitleMarker(input: {
  contentTitle: string | null | undefined;
}): boolean {
  const { contentTitle } = input;
  if (typeof contentTitle !== "string") {
    return false;
  }

  const trimmedTitle = contentTitle.trim();
  return (
    trimmedTitle === SEEDED_VERSION_TITLE_PLACEHOLDER ||
    EMPTY_TITLE_MARKER_PATTERN.test(trimmedTitle)
  );
}

export function isBlankContent(input: {
  content: string | null | undefined;
}): boolean {
  const { content } = input;
  if (typeof content !== "string") {
    return true;
  }

  return content.trim().length === 0;
}

export function isEmptyContentTile(input: {
  contentTitle: string | null | undefined;
  content: string | null | undefined;
}): boolean {
  return isBlankContent({ content: input.content });
}

export function isEmptyTimelineVersion(input: {
  isEmptyContent: boolean | null | undefined;
  contentTitle: string | null | undefined;
}): boolean {
  return input.isEmptyContent === true;
}

export function getDisplayContentTitle(input: {
  contentTitle: string | null | undefined;
  fallbackTitle?: string | null | undefined;
}): string | undefined {
  if (!hasEmptyContentTitleMarker({ contentTitle: input.contentTitle })) {
    return input.contentTitle ?? undefined;
  }

  const fallbackTitle = input.fallbackTitle?.trim();
  return fallbackTitle && !hasEmptyContentTitleMarker({ contentTitle: fallbackTitle })
    ? fallbackTitle
    : UNTITLED_VERSION_LABEL;
}
